module.exports = __webpack_public_path__ + "static/media/mask.102120ad.svg";